import { GlobalStateContext, type GlobalStateContextValue } from "@src/context/globalState/GlobalStateContext";
import * as React from "react";

export const useGlobalState = (): GlobalStateContextValue => {
    return React.useContext(GlobalStateContext);
};
